import { Tag, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { AcquisitionType, MarketplaceOfferSelectData } from '../types/types';

const { Text } = Typography;

export type OfferOptionData = MarketplaceOfferSelectData;

const acquisitionTypeColor: Record<string, string> = {
  [AcquisitionType.Subscription]: 'blue',
  [AcquisitionType.Purchase]: 'green',
  [AcquisitionType.Rental]: 'cyan',
};

const formatPrice = (value?: number) =>
  (value ?? 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

interface OfferOptionItemProps {
  data: OfferOptionData;
  compact?: boolean;
}

export const OfferOptionItem: React.FC<OfferOptionItemProps> = ({
  data,
  compact = false,
}) => {
  const typeColor = acquisitionTypeColor[data.type] ?? 'default';
  const offerId = data.offerId || data.id?.toString() || '-';
  const price = Number.isFinite(data.fullPrice) ? data.fullPrice : 0;

  return (
    <Wrapper $compact={compact}>
      <Text
        strong={!compact}
        style={{ fontSize: compact ? 12 : 13, flexShrink: 0 }}
      >
        {data.name}
      </Text>

      <Separator>|</Separator>

      <Text
        type='secondary'
        style={{ fontSize: compact ? 12 : 13, flexShrink: 0 }}
      >
        ID: {offerId}
      </Text>

      <Separator>|</Separator>

      <Text style={{ fontSize: compact ? 12 : 13, flexShrink: 0 }}>
        {formatPrice(price)}
      </Text>

      <TagGroup>
        {data.acquisitionName && (
          <Tag color={typeColor} style={{ margin: 0 }}>
            {data.acquisitionName}
          </Tag>
        )}

        {data.seasonalityName && (
          <Tag color='default' style={{ margin: 0 }}>
            {data.seasonalityName}
          </Tag>
        )}

        {data.typeName && (
          <Tag color='warning' style={{ margin: 0 }}>
            {data.typeName}
          </Tag>
        )}

        {data.tag && (
          <Tag color='error' style={{ margin: 0 }}>
            {data.tag}
          </Tag>
        )}
      </TagGroup>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $compact: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ $compact }) => ($compact ? '6px' : '8px')};
  flex-wrap: nowrap;
  overflow: hidden;
  min-width: 0;
`;

const Separator = styled.span`
  color: #595959;
  flex-shrink: 0;
  font-size: 12px;
`;

const TagGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;
